import { render } from "./MentionLegale.vue?vue&type=template&id=7d9e6889&ts=true"
import script from "./MentionLegale.vue?vue&type=script&lang=ts"
export * from "./MentionLegale.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__